/* Routing */
import { Link, useLocation } from "react-router-dom";
/* Contexts */
import useAuth from "../../hooks/useAuth";
/* Resources */
import useDeceased from "../../hooks/useDeceased";
import { useEffect, useRef, useState } from "react";
import { safeJwtDecode } from "../../helper/jwtHelper";
import usePager from "../../hooks/usePager";
import { getDeceasedList } from "../../api/pro/deceasedReq";
import useRefreshToken from "../../hooks/useRefreshToken";
export default function Header({ locationComp, location, parent, slug, agencyInfo }) {
    const { setDeceasedList, lastDeceased } = useDeceased();
    const { auth } = useAuth();
    const inputSearchRef = useRef();
    const isSearchingRef = useRef(false);
    const isMountedRef = useRef(false);
    const { currentPage, itemsPerPage, setTotalPages } = usePager();
    const [totalItems, setTotalItems] = useState();
    const [searchKeywords, setSearchKeywords] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { pathname } = useLocation();
    const token = auth?.token;
    const decodedToken = safeJwtDecode(token);
    const username = decodedToken?.userFullName;
    const agencyLogo = decodedToken?.agency_logo;
    const agencyId = decodedToken?.agency;
    const refresh = useRefreshToken();


    const apiDeceasedList = async (keywords = '', page = null, forceSearch = false) => {
        if (isSearchingRef.current && !forceSearch) {
            return;
        }

        const pageToUse = page !== null ? page : currentPage;
        const response = await getDeceasedList(token, agencyId, pageToUse, itemsPerPage, keywords);
        setDeceasedList(response?.deceasedList)
        setTotalItems(response?.totalItems)
    }

    const handleInputChange = (e) => {
        const searchValue = e.target.value;
        setSearchKeywords(searchValue);

        if (!searchValue || searchValue.length === 0) {
            if (isSearchingRef.current) {
                isSearchingRef.current = false;
                setIsLoading(true);
                setTimeout(async () => {
                    await apiDeceasedList('', currentPage, true);
                    setIsLoading(false);
                }, 0);
            }
        }
    };

    const handleSearch = async (e) => {
        e?.preventDefault();
        e?.stopPropagation();
        if (searchKeywords && searchKeywords.length >= 3) {
            isSearchingRef.current = true;
            setIsLoading(true);

            await new Promise(resolve => setTimeout(resolve, 0));

            await apiDeceasedList(searchKeywords, 1, true);

            setTimeout(async () => {
                if (isSearchingRef.current) {
                    await apiDeceasedList(searchKeywords, 1, true);
                    setIsLoading(false);
                }
            }, 150);
        }
    };

    const handleClearSearch = async (e) => {
        e?.preventDefault();
        e?.stopPropagation();
        setIsLoading(true);
        setSearchKeywords('');
        if (inputSearchRef.current) {
            inputSearchRef.current.value = '';
        }
        isSearchingRef.current = false;

        await apiDeceasedList('', currentPage, true);
        setIsLoading(false);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleSearch();
        }
    };

    useEffect(() => {
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [totalItems, itemsPerPage, setTotalPages]);

    useEffect(() => {
        if (isLoading) {
            document.body.classList.add('search-loading');
        } else {
            document.body.classList.remove('search-loading');
        }
        return () => {
            document.body.classList.remove('search-loading');
        };
    }, [isLoading]);

    useEffect(() => {
        let titleParts = [];
        if (location) titleParts.push(location);
        if (parent) titleParts.push(parent);

        let fullTitle = titleParts.length > 0
            ? `${titleParts.join(' - ')} - Obsèques en France`
            : "Obsèques en France";

        if (location === "Tableau de bord") {
            fullTitle = "Accueil - Obsèques en France";
        }

        document.title = fullTitle;
    }, [location, parent]);

    useEffect(() => {
        if (!isMountedRef.current) {
            isMountedRef.current = true;
            isSearchingRef.current = false;
            apiDeceasedList('', currentPage, true);
            return;
        }

        apiDeceasedList('', currentPage, false);
    }, [agencyId, currentPage, itemsPerPage]);


    const handleSwitchExit = async () => {
        if (decodedToken?.roles.includes("ROLE_PREVIOUS_ADMIN")) {
            localStorage.setItem("refresh_token", localStorage.getItem("old_refresh_token"));
            localStorage.removeItem("old_refresh_token");
            await refresh(localStorage.getItem("refresh_token"));

            await new Promise(resolve => setTimeout(resolve, 100));

            window.location.href = "/admin/utilisateurs";
        }
    }

    return (
        <header>
            <div className="header-first">
                {parent ? (
                    <h1 className="header-title">
                        <nav className="breadcrumb">
                            <Link to={slug} className="breadcrumb-link">
                                <i className="fa fa-arrow-left" />
                                <span>{parent}</span>
                            </Link>
                            {location &&
                                <span className="breadcrumb-crumb">
                                    <i className="fa fa-chevron-right breadcrumb-sep" />
                                    <span className="breadcrumb-text">{location.trim()}</span>
                                </span>
                            }
                            {locationComp &&
                                <span className="breadcrumb-crumb">
                                    <i className="fa fa-chevron-right breadcrumb-sep" />
                                    <span className="breadcrumb-text breadcrumb-current">{locationComp.trim()}</span>
                                </span>
                            }
                        </nav>
                    </h1>

                ) : (
                    <h1>
                        {(!pathname.includes("admin")) &&
                            <div className="header-title">
                                <span className="breadcrumb">
                                    <span className="breadcrumb-text breadcrumb-current">{location}</span>
                                </span>
                            </div>
                        }
                    </h1>
                )
                }
                {auth?.roles?.includes("ROLE_PREVIOUS_ADMIN") &&
                    <button className={`switch-off red-button ${pathname?.includes("faire-part") ? "fpr-page" : ""}`} onClick={handleSwitchExit}>
                        <i className="fa fa-power-off" /><span>Revenir à mon compte</span>
                    </button>
                }
            </div>
            {location === "Tableau de bord" &&
                <div className="header-title welcome">
                    <div className="welcome-info">
                        <span className="welcome-user">Bienvenue {username}</span>
                        <span className="current-date">
                            {new Date().toLocaleDateString('fr-FR', {
                                weekday: 'long',
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </span>
                        {location === "Tableau de bord" && <div className="search-input">
                            <input
                                ref={inputSearchRef}
                                type="search"
                                placeholder="Rechercher (3 car. min.)"
                                name="search-deceased"
                                onChange={handleInputChange}
                                onKeyPress={handleKeyPress}
                                minLength={3}
                                value={searchKeywords}
                                className={searchKeywords ? "has-clear-btn" : ""}
                                disabled={isLoading}
                            />
                            {searchKeywords && !isLoading && (
                                <span
                                    className="clear-search"
                                    onClick={handleClearSearch}
                                    title="Annuler la recherche"
                                >
                                    <i className="fa fa-times" />
                                </span>

                            )}
                            {isLoading ? (
                                <>
                                    <span className="search-spinner" title="Recherche en cours...">
                                        <i className="fa fa-spinner fa-spin" />
                                    </span>
                                </>

                            ) : (
                                <>

                                    <span onClick={handleSearch} title="Rechercher"><i className="fa fa-search" /></span>
                                </>
                            )}
                        </div>}
                    </div>
                    <p className="last-deceased">
                        {lastDeceased && `Dernier défunt consulté : ${lastDeceased}`}
                    </p>
                </div>
            }
        </header>
    )
}
